import React, { useState } from 'react';
import { Link } from 'react-router';
import { FaBars, FaTimes } from 'react-icons/fa';

const links = [
  { to: '/classes', label: 'Classes' },
  { to: '/reviews', label: 'Reviews' },
  { to: '/about', label: 'About Us' },
  { to: '/contact', label: 'Contact' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const close = () => setMenuOpen(false);

  return (
    <header className="sticky top-0 z-50 border-b border-navy/10 bg-white shadow-sm">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
        <Link to="/" onClick={close} className="flex items-center gap-3">
          <img
            src="/images/logo.png"
            alt="Velocity Learning"
            className="h-14 w-14 object-contain"
          />
          <span className="text-xl font-bold tracking-tight text-navy">
            Velocity Learning
          </span>
        </Link>

        <button
          type="button"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          className="text-2xl text-navy lg:hidden"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul className="hidden items-center gap-8 lg:flex">
          {links.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className="text-lg font-medium text-navy transition hover:text-navy-light"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {menuOpen && (
        <ul className="border-t border-navy/10 bg-white pb-4 lg:hidden">
          {links.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                onClick={close}
                className="block px-5 py-3 text-lg font-medium text-navy"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </header>
  );
};

export default Header;
